import { render, staticRenderFns } from "./MultipollCreateForm.vue?vue&type=template&id=cf7be7fa&scoped=true&"
import script from "./MultipollCreateForm.vue?vue&type=script&lang=ts&"
export * from "./MultipollCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7be7fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
